import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { cn } from "@/lib/utils"
import { countryCodes } from "@/components/areacodes"

interface ContactItemProps {
  contact: Contact
  selected: boolean
  showLastMessage?: boolean
  onSelect: (id: string) => void
}

export function ContactItem({ contact, selected, showLastMessage, onSelect }: ContactItemProps) {

  const code = contact.code && countryCodes[contact.code] ? countryCodes[contact.code].name : ""

  return <button onClick={() => onSelect(contact.id!)} className={cn("w-full flex items-center gap-3 px-4 py-3 hover:bg-muted/50 transition-colors text-left border-b border-border/50", selected && "bg-muted")}>

    <div className="relative shrink-0">
      <Avatar>
        <AvatarImage src={contact.avatar} alt={contact.name} />
        <AvatarFallback>{contact.name?.[0]?.toUpperCase() ?? "?"}</AvatarFallback>
      </Avatar>
      {/* {contact.code && countryCodes[contact.code] && (
        <span className="absolute bottom-0 left-0 text-[12px] leading-none">{countryCodes[contact.code].flag}</span>
      )} */}
    </div>

    <div className="flex-1 min-w-0">
      <div className="flex items-center justify-between">
        <span className="text-foreground text-sm font-medium truncate">{contact.name}</span>
        <span className={cn("text-xs shrink-0 ml-2", contact.unreadCount && contact.unreadCount > 0 ? "text-emerald-600 font-medium" : "text-muted-foreground")}>
          {contact.lastMessageTime}
        </span>
      </div>
      <div className="flex items-center justify-between mt-0.5">

        {showLastMessage && <span className="text-muted-foreground text-xs truncate">{contact.lastMessage}</span>}

        {!showLastMessage && <span className="text-muted-foreground text-xs truncate">{code}</span>}

        {contact.unreadCount != null && contact.unreadCount > 0 &&
          <span className="ml-2 shrink-0 h-5 min-w-5 rounded-full bg-emerald-600 text-white text-[10px] font-semibold flex items-center justify-center px-1">
            {contact.unreadCount}
          </span>
        }

      </div>
    </div>
  </button>
}
